module.exports = __webpack_public_path__ + "static/2.1_1440x540_Desktop_Hero_1X-812b0bfe509db43d0e427d659091b857.png";